// extracted by mini-css-extract-plugin
export default {"modalsCalled":"DnvEDD9hQy5FsInY6eaz"};